import { InsuredInformationBreadcrumb } from 'quick-quote/components'

import BasicPlanCalculation from 'quick-quote/product-common/coverage-plan/components/basic-plan/basic-plan-calculation'
import RiderGroup from 'quick-quote/product-common/coverage-plan/components/rider/rider-group'
import TotalPremiumInput from 'quick-quote/product-common/coverage-plan/components/basic-plan/total-premium-input'
import PensionType from 'quick-quote/product-retirement/coverage-plan/components/pension-plan'
import PATH from 'quick-quote/constants/path'
import { Redirect } from 'react-router-dom'

const CoveragePlan = ({
  toggleRider,
  riderCodes,
  pensionType,
  canProceedToCoveragePlan,
  editRiderSumAssured,
  editRiderSelectedPlan,
  editPensionType,
  infoMessage,
}) => {
  if (!canProceedToCoveragePlan) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  }
  return (
    <div>
      <InsuredInformationBreadcrumb />
      <div id="coverage-plan">
        <div className="content">
          <BasicPlanCalculation />
          <div id="total-premium">
            <TotalPremiumInput />
          </div>
          <div id="pension-select">
            <PensionType pensionType={pensionType} editPensionType={editPensionType} />
          </div>
          <RiderGroup
            riderCodes={riderCodes}
            toggleRider={toggleRider}
            editRiderSumAssured={editRiderSumAssured}
            editRiderSelectedPlan={editRiderSelectedPlan}
            infoMessage={infoMessage}
          />
        </div>
      </div>
    </div>
  )
}

export default CoveragePlan
